import React, { useState, useEffect, useRef } from "react";
import "./Optimizer.css";
import hdIcon from "../hd-icon.svg";
import sdIcon from "../sd-icon.svg";
import thumbIcon from "../thumb-icon.svg";
import addIcon from "../add-icons.svg";
import rightIcon from "../right-icons.svg";
import PackDescriptionComponent from "../PackDesription/PackDescriptionComponent";
export default function OptimizerComponent(props) {
  console.log(props, "props");
  const { yourSelection, bestFitPack ,showMaximumChat} = props.data;

  const { filterToggle, onClickSubmit, code, tag } = props;
  const [yourSelectionData, setYourSelectionData] = useState(yourSelection);
  const [bestFitPackData, setBestFitPackData] = useState(bestFitPack);
  const [refresh, setRefresh] = useState(false);
  const [dataToBeSent, setDataToBeSent] = useState({});
  const [enableDescriptionComponent, setEnableDescriptionComponent] = useState({
    toggle: false,
    data: null,
  });
  const [disabled, setDisabled] = useState(true);
  const [confirmed, setConfirmed] = useState(false);
  const confirmRef = useRef(null);
  //useEffects

  useEffect(() => {
    const container = document.querySelector(".optimizerComponentContainer");
    if (container) {
        container.style.position = "fixed";
        container.style.top = "0";
        container.style.left = "0";
        container.style.width = "100vw";
        container.style.height = "100vh";
        container.style.zIndex = "9999";
    }
}, []);

  useEffect(() => {
    yourSelectionData.checked = false;
    bestFitPackData.checked = false;
  }, []);
  useEffect(() => {
    if (
      yourSelectionData.checked === false &&
      bestFitPackData.checked === false
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [refresh]);
  const scrollOnAction = () => {
    confirmRef.current.scrollIntoView();
  };
  const selectYourSelection = () => {
    scrollOnAction();
    setRefresh(!refresh);
    if (yourSelectionData.checked === false) {
      const tempSelection = yourSelection;
      tempSelection.checked = true;
      bestFitPack.checked = false;
      setYourSelectionData(tempSelection);
      setDataToBeSent({ key1: "Selected" });
      console.log(yourSelectionData);
    } else {
      const tempSelection = yourSelection;
      tempSelection.checked = false;
      setYourSelectionData(tempSelection);
      console.log(yourSelectionData);
    }
    setRefresh(!refresh);
  };
  const selectBestFitPack = () => {
    scrollOnAction();
    setRefresh(!refresh);
    if (bestFitPackData.checked === false) {
      const tempBestPack = bestFitPack;
      tempBestPack.checked = true;
      yourSelection.checked = false;
      setBestFitPackData(tempBestPack);
      console.log(bestFitPackData);
      setDataToBeSent({ key1: "Optimized" });
    } else {
      const tempBestPack = bestFitPack;
      tempBestPack.checked = false;
      setBestFitPackData(tempBestPack);
      console.log(bestFitPackData);
    }
    setRefresh(!refresh);
  };

  const handleSubmit = () => {
    console.log(code, dataToBeSent, tag, "in optimizer component");
    onClickSubmit(code, JSON.stringify({dataToBeSent}), tag);
    if (dataToBeSent.key1 === "Selected") {
      localStorage.setItem(
        "selectedOptimizer",
        JSON.stringify({ optimizer: "Selected" })
      );
    } else {
      localStorage.setItem(
        "selectedOptimizer",
        JSON.stringify({ optimizer: "BestFit" })
      );
    }
    filterToggle(true);
    setDisabled(true);
    setConfirmed(true);
  };
  // const onPackClickHandler = (pack) => {
  //   var temp = [];
  //   if (pack.checked === false) {
  //     pack.checked = true;
  //     temp = packs.map((onePack) =>
  //       onePack.name === pack.name ? pack : onePack
  //     );
  //   } else {
  //     pack.checked = false;
  //     temp = packs.map((onePack) =>
  //       onePack.name === pack.name ? pack : onePack
  //     );
  //   }

  //   setPacks(temp);
  // };
  const enableDescription = (data) => {
    localStorage.setItem("packDescription", JSON.stringify(data));
    setEnableDescriptionComponent({
      toggle: true,
      data: data,
    });
  };
  const selectDescription = (data) => {
    // onPackClickHandler(enableDescriptionComponent.data);
    setEnableDescriptionComponent({
      toggle: false,
      data: null,
    });
  };
  return (
    <div className="optimizerComponenetContainer">
      {enableDescriptionComponent.toggle && (
        <PackDescriptionComponent
          data={enableDescriptionComponent.data}
          closeDescriptionComponent={() => setEnableDescriptionComponent(false)}
          selectDesctipon={() => selectDescription()}
          showMaximumChat={showMaximumChat}
        />
      )}
      {yourSelection !== undefined ? (
        <div
          className="yourSelectionBox"
          onClick={() => selectYourSelection()}
          style={{
            border:
              yourSelectionData.checked === true
                ? "1px solid #E10092 "
                : "1px solid rgba(206,210,218,0.6)",
          }}
        >
          <div className="boxSelection-header">
            <div className="boxSelection-header-radioContainer">
              <input
                type="radio"
                name="yourSelection"
                value="1"
                checked={yourSelectionData.checked}
                style={{cursor:'pointer'}}
              />
              <p>Your Selection</p>
            </div>
            <div className="boxselection-priceContainer-yourPack">
              <p>{yourSelectionData.price}</p>
            </div>
          </div>
          <div className="boxselection-hdsdContainer">
            <span></span>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "2%",
                marginRight: "2%",
              }}
            >
              <img src={hdIcon} /> <p>{yourSelectionData.noOfHdChannels}</p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "2%",
                marginRight: "2%",
              }}
            >
              <img src={sdIcon} /> <p>{yourSelectionData.noOfSdChannels}</p>
            </div>
            <span></span>
          </div>
          <div className="optimizer-description-container">
            <img src={thumbIcon} width="15px" height="15px" />
            <p>{yourSelectionData.description}</p>
          </div>
          <div
            className="optimizer-channelList"
            onClick={() => enableDescription(yourSelectionData)}
          >
            <p>View Channels List</p>
            <img src={rightIcon} width="15px" height="15px" />
          </div>
        </div>
      ) : null}
      <div
        className="bestFiltBox"
        onClick={() => selectBestFitPack()}
        style={{
          border:
            bestFitPackData.checked === true
              ? "1px solid #E10092 "
              : "1px solid rgba(206,210,218,0.6)",
          display: "none",
        }}
      >
        <div class="offer-tag-div">Offer for you</div>
        <div className="boxSelection-header">
          <div className="boxSelection-header-radioContainer">
            <input
              type="radio"
              name="yourSelection"
              value="1"
              checked={bestFitPackData.checked}
              style={{ cursor: "pointer" }}
            />
            <p>Best Fit Pack</p>
          </div>
          <div className="boxselection-priceContainer">
            <p>{bestFitPackData.price}</p>
            <p>You Save {bestFitPackData.benefitPrice}</p>
          </div>
        </div>
        <div className="boxselection-hdsdContainer">
          <span></span>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <img src={hdIcon} /> <p>{bestFitPackData.noOfHdChannels}</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <img src={sdIcon} /> <p>{bestFitPackData.noOfSdChannels}</p>
          </div>
          <span></span>
        </div>

        <div className="optimizer-description-container">
          <img
            src={thumbIcon}
            width="15px"
            height="15px"
            className="thumns-icon"
          />
          <p>{bestFitPackData.description}</p>
        </div>
        <div className="optimizer-description-container">
          <img src={addIcon} width="15px" height="15px" />
          <p>{bestFitPackData.benefitDescription}</p>
        </div>
        <div
          className="optimizer-channelList"
          onClick={() => enableDescription(bestFitPackData)}
        >
          <p>View Channels List</p>
          <img src={rightIcon} width="15px" height="15px" />
        </div>
      </div>
      <div
        ref={confirmRef}
        className="BoxSelection-button waves-effect waves-light"
        style={{ opacity: confirmed || disabled ? 0.5 : 1 }}
      >
        <button
          onClick={() => !confirmed && !disabled && handleSubmit(dataToBeSent)}
          disabled={disabled}
        >
          Confirm Pack
        </button>
      </div>
    </div>
  );
}
